

















































import { Component, Vue } from 'vue-property-decorator';
@Component({})
  export default class FrameB extends Vue {
    /* TODO: Move data to service */
    private data() {
      return {
        items: [
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/danko-v1.appspot.com/o/carousel%2Fsmoredanko_350.jpg?alt=media&token=160df29c-39ae-48c5-9b74-bd9fcd166ce5',
            height: '500px',
            link: '/recipes',
            buttonText: 'Recipes',
            knockout: true,
            serif: false,
          },
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/danko-v1.appspot.com/o/carousel%2Fjuice_350.jpg?alt=media&token=6e407601-4449-4364-9529-677af433bd48',
            height: '500px',
          },
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/danko-v1.appspot.com/o/carousel%2Fcocktail_350.jpg?alt=media&token=7994ad9f-a1c8-4d81-b07b-9a7cb1b03000',
            height: '500px',
            link: '/recipes',
            buttonText: 'Recipes',
            knockout: true,
            serif: false,
          },
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/danko-v1.appspot.com/o/carousel%2Ffrosty_350.jpg?alt=media&token=f22cbfe0-857a-46e2-9c0e-ccef9f4d8a8a',
            height: '500px',
          },
        ],
        frameTwo: {
          gearA: {
            url: require('../../assets/home-mech/frame-B/gear-A_130x130.png'),
            alt: 'frame two gear A',
            highlight: require('../../assets/home-mech/frame-B/gear-A-high_130x130.png'),
            highAlt: 'frame two gear A highlight',
          },
          gearB: {
            url: require('../../assets/home-mech/frame-B/gear-B_82x82.png'),
            alt: 'frame two gear B',
            highlight: require('../../assets/home-mech/frame-B/gear-B-high_82x82.png'),
            highAlt: 'frame two gear B highlight',
          },
          gearC: {
            url: require('../../assets/home-mech/frame-B/gear-C_36x36.png'),
            alt: 'frame two gear C',
            highlight: require('../../assets/home-mech/frame-B/gear-C-high_36x36.png'),
            highAlt: 'frame two gear C highlight',
          },
          gearD: {
            url: require('../../assets/home-mech/frame-B/gear-D_170x170.png'),
            alt: 'frame two gear D',
            highlight: require('../../assets/home-mech/frame-B/gear-D-high_170x170.png'),
            highAlt: 'frame two gear D highlight',
          },
          gearE: {
            url: require('../../assets/home-mech/frame-B/gear-E_72x72.png'),
            alt: 'frame two gear E',
            highlight: require('../../assets/home-mech/frame-B/gear-E-high_72x72.png'),
            highAlt: 'frame two gear E highlight',
          },
          gearF: {
            url: require('../../assets/home-mech/frame-B/gear-F_48x48.png'),
            alt: 'frame two gear F',
            highlight: require('../../assets/home-mech/frame-B/gear-F-high_48x48.png'),
            highAlt: 'frame two gear F highlight',
          },
        },
      };
    }
  }
